import React from 'react';
import { Phone, CheckCircle, Briefcase, FileSearch, Shield, TrendingUp } from 'lucide-react';
export function ProfessionalWitnessPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7866">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7867">
        <div className="container mx-auto px-4" data-id="element-7868">
          <p className="text-center text-lg mb-4 italic" data-id="element-7869">
            Serving Farmington Hills, Farmington, Novi, Livonia, Northville
            Since 1958
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7870">
            Professional Witness Service
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7871">
            Truck and Equipment Expert Witness
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7872">
        <div className="max-w-5xl mx-auto" data-id="element-7873">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7874">
            <div className="flex items-center mb-6" data-id="element-7875">
              <Briefcase className="text-[#B1050B] mr-4" size={40} data-id="element-7876" />
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-7877">
                Truck and Equipment Expert Witness
              </h2>
            </div>

            <p className="text-lg text-gray-700 mb-6" data-id="element-7878">
              <strong data-id="element-7879">Garrett Auto And Truck Service</strong> provides
              comprehensive expert witness and consulting services for truck and
              equipment matters.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-7880">
            {/* Onsite Inspections */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-7881">
              <div className="flex items-start mb-4" data-id="element-7882">
                <div className="bg-blue-100 rounded-lg p-3 mr-4" data-id="element-7883">
                  <FileSearch className="text-blue-600" size={28} data-id="element-7884" />
                </div>
                <div data-id="element-7885">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7886">
                    Onsite Equipment Safety Inspection
                  </h3>
                  <p className="text-gray-600" data-id="element-7887">
                    Post accident inspection and comprehensive safety
                    evaluations
                  </p>
                </div>
              </div>
            </div>

            {/* Equipment Specifications */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-7888">
              <div className="flex items-start mb-4" data-id="element-7889">
                <div className="bg-green-100 rounded-lg p-3 mr-4" data-id="element-7890">
                  <CheckCircle className="text-green-600" size={28} data-id="element-7891" />
                </div>
                <div data-id="element-7892">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7893">
                    Equipment Specifications
                  </h3>
                  <p className="text-gray-600" data-id="element-7894">
                    Evaluating equipment specifications - buy the right
                    equipment the first time
                  </p>
                </div>
              </div>
            </div>

            {/* Lease & Purchase Evaluation */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-7895">
              <div className="flex items-start mb-4" data-id="element-7896">
                <div className="bg-purple-100 rounded-lg p-3 mr-4" data-id="element-7897">
                  <TrendingUp className="text-purple-600" size={28} data-id="element-7898" />
                </div>
                <div data-id="element-7899">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7900">
                    Lease & Purchase Negotiation
                  </h3>
                  <p className="text-gray-600" data-id="element-7901">
                    Evaluating and negotiating equipment leases and purchases -
                    Used or New equipment
                  </p>
                </div>
              </div>
            </div>

            {/* Trade Cycles */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-7902">
              <div className="flex items-start mb-4" data-id="element-7903">
                <div className="bg-orange-100 rounded-lg p-3 mr-4" data-id="element-7904">
                  <Shield className="text-orange-600" size={28} data-id="element-7905" />
                </div>
                <div data-id="element-7906">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7907">
                    Equipment Trade Cycles
                  </h3>
                  <p className="text-gray-600" data-id="element-7908">
                    Determining optimal equipment trade cycles for maximum value
                  </p>
                </div>
              </div>
            </div>

            {/* Maintenance Auditing */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-7909">
              <div className="flex items-start mb-4" data-id="element-7910">
                <div className="bg-red-100 rounded-lg p-3 mr-4" data-id="element-7911">
                  <FileSearch className="text-red-600" size={28} data-id="element-7912" />
                </div>
                <div data-id="element-7913">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7914">
                    Maintenance Operations Auditing
                  </h3>
                  <p className="text-gray-600" data-id="element-7915">
                    Auditing for scheduled maintenance operations and compliance
                  </p>
                </div>
              </div>
            </div>

            {/* Cost Tracking */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-7916">
              <div className="flex items-start mb-4" data-id="element-7917">
                <div className="bg-teal-100 rounded-lg p-3 mr-4" data-id="element-7918">
                  <TrendingUp className="text-teal-600" size={28} data-id="element-7919" />
                </div>
                <div data-id="element-7920">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7921">
                    Maintenance Cost Evaluation
                  </h3>
                  <p className="text-gray-600" data-id="element-7922">
                    Evaluating and tracking maintenance costs for budget
                    optimization
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Budgeting Plan */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-7923">
            <div className="flex items-center mb-4" data-id="element-7924">
              <Briefcase className="mr-4" size={32} data-id="element-7925" />
              <h3 className="text-2xl font-bold" data-id="element-7926">
                Custom Tailored Budgeting Plan
              </h3>
            </div>
            <p className="text-lg text-gray-100" data-id="element-7927">
              Evaluating and implementing a custom tailored budgeting plan
              designed specifically for your fleet and equipment needs
            </p>
          </div>

          {/* Complete Services List */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7928">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-7929">
              Complete Services Overview
            </h2>

            <div className="space-y-4" data-id="element-7930">
              <div className="flex items-start" data-id="element-7931">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7932" />
                <p className="text-gray-700" data-id="element-7933">
                  <strong data-id="element-7934">
                    Onsite equipment safety inspection or post accident
                    inspection
                  </strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-7935">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7936" />
                <p className="text-gray-700" data-id="element-7937">
                  <strong data-id="element-7938">Evaluating equipment specifications</strong> - buy the
                  right equipment the first time
                </p>
              </div>

              <div className="flex items-start" data-id="element-7939">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7940" />
                <p className="text-gray-700" data-id="element-7941">
                  <strong data-id="element-7942">
                    Evaluating and negotiating equipment leases and purchases
                  </strong>{' '}
                  - Used or New equipment
                </p>
              </div>

              <div className="flex items-start" data-id="element-7943">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7944" />
                <p className="text-gray-700" data-id="element-7945">
                  <strong data-id="element-7946">Determining equipment trade cycles</strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-7947">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7948" />
                <p className="text-gray-700" data-id="element-7949">
                  <strong data-id="element-7950">Auditing for scheduled maintenance operations</strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-7951">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7952" />
                <p className="text-gray-700" data-id="element-7953">
                  <strong data-id="element-7954">Evaluating and tracking maintenance costs</strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-7955">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-7956" />
                <p className="text-gray-700" data-id="element-7957">
                  <strong data-id="element-7958">
                    Evaluating and implementing a custom tailored budgeting plan
                  </strong>
                </p>
              </div>
            </div>
          </div>

          {/* Featured Service Highlight */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-7959">
            <div className="flex flex-col md:flex-row items-center" data-id="element-7960">
              <div className="flex-1 mb-6 md:mb-0 md:mr-8" data-id="element-7961">
                <h2 className="text-3xl font-bold mb-4" data-id="element-7962">
                  Onsite Equipment Safety Inspection
                </h2>
                <p className="text-xl text-gray-100 mb-4" data-id="element-7963">
                  Post accident inspection and comprehensive safety evaluations
                </p>
                <p className="text-gray-200" data-id="element-7964">
                  Our expert team provides thorough onsite inspections to
                  evaluate equipment safety, identify potential issues, and
                  provide detailed reports for legal and insurance purposes.
                </p>
              </div>
              <div className="flex-shrink-0" data-id="element-7965">
                <div className="bg-white/10 rounded-lg p-6" data-id="element-7966">
                  <Shield className="text-white" size={80} data-id="element-7967" />
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7968">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-7969">
              Why Choose Garrett Auto & Truck Service?
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-7970">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7971">
                <h3 className="font-bold text-blue-900 mb-3" data-id="element-7972">
                  65+ Years of Experience
                </h3>
                <p className="text-gray-700" data-id="element-7973">
                  Serving the community since 1958 with unmatched expertise
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-7974">
                <h3 className="font-bold text-green-900 mb-3" data-id="element-7975">
                  Comprehensive Knowledge
                </h3>
                <p className="text-gray-700" data-id="element-7976">
                  Deep understanding of truck and equipment systems,
                  specifications, and industry standards
                </p>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-7977">
                <h3 className="font-bold text-purple-900 mb-3" data-id="element-7978">
                  Detailed Reporting
                </h3>
                <p className="text-gray-700" data-id="element-7979">
                  Thorough documentation and expert testimony for legal
                  proceedings
                </p>
              </div>

              <div className="bg-orange-50 rounded-lg p-6" data-id="element-7980">
                <h3 className="font-bold text-orange-900 mb-3" data-id="element-7981">
                  Local Expertise
                </h3>
                <p className="text-gray-700" data-id="element-7982">
                  Serving Farmington Hills, Farmington, Novi, Livonia, and
                  Northville
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7983">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7984">
              Need Expert Witness Services?
            </h2>
            <p className="text-xl mb-6" data-id="element-7985">
              Contact us for professional truck and equipment expert witness
              consultation
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7986">
              <Phone className="mr-3" size={24} data-id="element-7987" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7988">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
            <p className="mt-2 text-gray-400 text-sm" data-id="element-7989">
              Serving the community since 1958
            </p>
          </div>
        </div>
      </div>
    </div>;
}